function CruPrivacy() {
  return (
    <div style={{ maxWidth: 720, margin: '60px auto', padding: '0 24px 80px', fontFamily: 'inherit', lineHeight: 1.7, color: '#222' }}>
      <h1 style={{ fontSize: '1.6rem', marginBottom: 4, color: '#2C5F2E' }}>Cru — Privacy Policy</h1>
      <p style={{ color: '#666', marginTop: 0, marginBottom: 32 }}>Last updated: July 2026</p>

      <p>
        Cru ("the App") is a crowd-sourced map of bike-friendly cafés. This policy explains what
        data is collected and how it is used. The App does not require an account or sign-in.
      </p>

      <h2>What we collect</h2>
      <ul>
        <li>
          <strong>Location</strong> — used on your device to centre the map and sort cafés by
          distance. Your location is not sent to or stored on our servers.
        </li>
        <li>
          <strong>Café submissions</strong> — when you submit a café, we collect the details you
          provide: name, location, description, and an optional submitter name. This becomes
          public content once the submission is verified.
        </li>
        <li>
          <strong>Photos</strong> — if you attach photos to a café submission, they are uploaded
          and stored so they can be shown alongside the café listing.
        </li>
        <li>
          <strong>Feedback</strong> — if you use the in-app feedback form, we collect your
          message and an optional email address, only if you choose to provide one.
        </li>
        <li>
          <strong>Crash and error reports</strong> — if the App encounters an error, a technical
          report (error message, stack trace, and where it happened) is sent automatically to
          help us fix bugs. These reports do not contain personal identifiers.
        </li>
      </ul>

      <h2>How we use it</h2>
      <ul>
        <li>Café submissions are reviewed manually before being shown publicly on the map.</li>
        <li>Photos are displayed alongside the café listing once it is verified.</li>
        <li>Feedback is read by the developer to improve the App and is not shared further.</li>
        <li>Crash reports are used only to identify and fix bugs.</li>
      </ul>
      <p>We do not sell your data or use it for advertising.</p>

      <h2>How it is stored</h2>
      <p>
        All data is stored on <a href="https://supabase.com" target="_blank" rel="noopener noreferrer">Supabase</a>,
        a cloud database platform. Supabase's privacy policy applies to the underlying infrastructure:&nbsp;
        <a href="https://supabase.com/privacy" target="_blank" rel="noopener noreferrer">supabase.com/privacy</a>.
      </p>

      <h2>Data sharing</h2>
      <p>
        Once a café submission is verified, its name, location, description, and photos become
        visible to everyone using the App — that's the point of a crowd-sourced map. Feedback
        messages and crash reports are private and only viewed by the developer.
      </p>

      <h2>Deleting your data</h2>
      <p>
        Since the App has no accounts, there is no single "delete my account" action. To request
        removal of a café submission, photo, or feedback message you've sent, contact us at the
        email below with enough detail to identify it (e.g. café name and approximate submission
        date), and we will remove it within 30 days.
      </p>

      <h2>Children</h2>
      <p>The App is not intended for use by children under 13. We do not knowingly collect data from children.</p>

      <h2>Changes</h2>
      <p>
        If this policy changes, the "Last updated" date above will be updated. Continued use of
        the App after a change constitutes acceptance of the new policy.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about this policy:&nbsp;
        <a href="mailto:dennis.hvel@gmail.com">dennis.hvel@gmail.com</a>
      </p>
    </div>
  );
}

export default CruPrivacy;
